import { LAYOUT } from '@/components/cpv-ui/tokens';
import Footer from './Footer';

/** The app's fixed footer bar, `left` px from the viewport's left edge (the drawer's width). Its height is LAYOUT.appFooter. */
export default function AppFooter({ left = 0 }) {
  return (
    <div
      data-testid="app-footer"
      className="fixed bottom-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-[1100] transition-all duration-300"
      style={{ position: 'fixed', bottom: 0, right: 0, left, height: LAYOUT.appFooter, boxSizing: 'border-box', overflow: 'hidden', width: `calc(100% - ${left}px)` }}
    >
      <Footer />
    </div>
  );
}
